import { onBeforeUnmount, ref } from 'vue'

import { isOnlyQrLayout as isTouchDeviceDetect } from '@/packages/is-only-qr-layout'

export function useIsOnlyQrLayout() {
    const isOnlyQrLayout = ref(isTouchDeviceDetect())

    window.addEventListener('resize', onResize, {
        passive: true,
    })

    function onResize() {
        isOnlyQrLayout.value = isTouchDeviceDetect()
    }

    onBeforeUnmount(() => {
        window.removeEventListener('resize', onResize)
    })

    return {
        isOnlyQrLayout,
    }
}
